import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EpisodeUsersServiceProxy, SubmitRatingDto } from '@shared/service-proxies/service-proxies';
import { AnalyticsService } from '@app/shared/services/analytics.service';

@Component({
    selector: 'smiley-rating',
    templateUrl: './smiley-rating.component.html',
    styleUrls: ['./smiley-rating.component.less'],
})
export class SmileyRatingComponent extends AppComponentBase implements OnInit, OnChanges {
    @Input() episodeId: number;
    @Input() existingRating: number | null;
    @Output() ratingSubmitted = new EventEmitter<number>();

    selectedRating: number | null = null;
    isSubmitting = false;
    hasRated = false;
    submitError = false;

    readonly emojis = ['😞', '😕', '😐', '🙂', '😄'];

    constructor(
        injector: Injector,
        private _episodeUsersServiceProxy: EpisodeUsersServiceProxy,
        private _analyticsService: AnalyticsService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.selectedRating = this.existingRating ?? null;
        if (this.existingRating != null) {
            this.hasRated = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['existingRating'] && !this.isSubmitting) {
            this.selectedRating = this.existingRating ?? null;
            if (this.existingRating != null) {
                this.hasRated = true;
            }
        }
    }

    onRatingClick(rating: number): void {
        if (this.isSubmitting) { return; }
        this.isSubmitting = true;
        this.submitError = false;
        this._episodeUsersServiceProxy
            .submitRating(new SubmitRatingDto({ episodeId: this.episodeId, rating }))
            .subscribe({
                next: () => {
                    this.isSubmitting = false;
                    this.selectedRating = rating;
                    this.hasRated = true;
                    this._analyticsService.pushEvent('rating_submitted', { episode_id: this.episodeId, rating });
                    this.ratingSubmitted.emit(rating);
                },
                error: () => {
                    this.isSubmitting = false;
                    this.submitError = true;
                },
            });
    }
}
